// extracted by mini-css-extract-plugin
export default {"svgContainer":"SvgContainer_svgContainer__KCzr1"};